import { GlobalConfigProps } from 'antd/lib/notification/interface';

export const DEFAULT_NOTIFICATION_GLOBAL_CONFIG: GlobalConfigProps = {
  placement: 'topRight',
  bottom: 24,
  top: 24,
};
